import { ShoppingBag } from "lucide-react";
import { externalLinkClickHandler } from "../../lib/openExternal";
import ProductThumb from "../commerce/ProductThumb";

/**
 * ProductGrid — renders the "Shop" section on /u/:slug legacy fallback.
 * Each card has an optional external Buy link that fires a click track.
 */
export function ProductGrid({ products, trackClick }) {
  if (!products || products.length === 0) return null;
  return (
    <section data-testid="creator-directory-products-section">
      <p className="overline mb-3">
        <ShoppingBag className="w-3 h-3 inline mr-1" /> Shop
      </p>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {products.map((p, i) => (
          <div
            key={p.product_id}
            className="rounded-2xl bg-white overflow-hidden flex flex-col"
            style={{ border: "1px solid var(--ux-border)", boxShadow: "var(--ux-shadow-1)" }}
            data-testid={`creator-directory-product-${i}`}
          >
            {/* v149.70 — No photo: the product's initials, not an empty box. */}
            <div className="flex" style={{ borderBottom: "1px solid var(--ux-border)" }}>
              <ProductThumb
                src={p.image_url}
                name={p.title}
                alt={p.title}
                width={640}
                className="w-full h-40"
                fallbackTestid={`creator-directory-product-initials-${i}`}
              />
            </div>
            <div className="p-3 flex-1 flex flex-col">
              <p className="font-bold text-sm truncate">{p.title}</p>
              {p.description && (
                <p className="text-xs mt-0.5 line-clamp-2" style={{ color: "var(--ux-ink-2)" }}>
                  {p.description}
                </p>
              )}
              <div className="mt-auto pt-2 flex items-center justify-between gap-2">
                <p className="font-display font-black text-lg tracking-tight">
                  {(p.currency || "USD")} {p.price}
                </p>
                {p.buy_url && (
                  <a
                    href={p.buy_url}
                    target="_blank"
                    rel="noreferrer"
                    onClick={externalLinkClickHandler(p.buy_url, () =>
                      trackClick("product", p.product_id, p.buy_url),
                    )}
                    className="rounded-full text-white px-3 py-1 font-semibold text-[11px]"
                    style={{ background: "var(--ux-coral)" }}
                    data-testid={`creator-directory-product-buy-${i}`}
                  >
                    Buy
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
